import { Tabs, Tab } from '@/components/Tab';
import Users from '@/pages/admin/user/user_list';
import { useStyletron } from '@tigergraph/app-ui-lib/Theme';
import { useSearchParams } from 'react-router-dom';

export default function Settings() {
  const [css] = useStyletron();
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <div
      className={css({
        padding: '16px 0 0',
        backgroundColor: '#fff',
      })}
    >
      <Tabs
        activeKey={searchParams.get('tab') || 'user'}
        onChange={({ activeKey }) => {
          const newSearchParams = new URLSearchParams(searchParams);
          newSearchParams.set('tab', `${activeKey}`);
          setSearchParams(newSearchParams);
        }}
        activateOnFocus
      >
        <Tab
          title="User"
          key="user"
          overrides={{
            TabPanel: {
              style: {
                paddingBottom: '0',
              },
            },
          }}
        >
          <Users />
        </Tab>
      </Tabs>
    </div>
  );
}
